import { z } from "zod";
import httpClient from "@/config/axios";

const personalMonthsSchema = z.object({
  home_group_id: z.string(),
  home_group_name: z.string(),
  months: z.array(
    z.object({
      year: z.number().int(),
      month: z.number().int().min(1).max(12),
      group_ids: z.array(z.string()),
    })
  ),
});
const issuedMonthsSchema = z.array(
  z.object({
    year: z.number().int(),
    month: z.number().int().min(1).max(12),
    schedule_id: z.string(),
  })
);
const wardsSchema = z.array(
  z.object({
    group_id: z.string(),
    group_name: z.string(),
    office_id: z.string().optional(),
  })
);

export async function fetchPersonalRosterMonths(signal?: AbortSignal) {
  return personalMonthsSchema.parse(
    await httpClient.get<unknown>("/roster/issued_roster/me/months", {
      signal,
      skipGroupIdInjection: true,
    })
  );
}
export async function fetchWardRosterMonths(
  groupId: string,
  signal?: AbortSignal
) {
  return issuedMonthsSchema.parse(
    await httpClient.get<unknown>("/roster/issued", {
      params: { group_id: groupId },
      signal,
    })
  );
}
export async function fetchRosterViewWards(
  isAdmin: boolean,
  signal?: AbortSignal
) {
  return wardsSchema.parse(
    await httpClient.get<unknown>(
      isAdmin ? "/groups" : "/groups/my-admin-groups",
      { signal, skipGroupIdInjection: true }
    )
  );
}

export type RosterViewDate = {
  readonly year: number;
  readonly month: number;
  readonly schedule_id: string;
};
export function rosterDateFromSearch(search: string): RosterViewDate | null {
  const params = new URLSearchParams(search);
  const year = Number(params.get("year")),
    month = Number(params.get("month"));
  return Number.isInteger(year) &&
    year >= 2000 &&
    year <= 2100 &&
    Number.isInteger(month) &&
    month >= 1 &&
    month <= 12
    ? { year, month, schedule_id: "" }
    : null;
}
export function rosterViewHref(
  scope: "my" | "all",
  date: RosterViewDate,
  groupId: string
) {
  const params = new URLSearchParams({
    year: String(date.year),
    month: String(date.month),
  });
  if (scope === "all" && groupId) params.set("group_id", groupId);
  return `/roster_view/${scope}?${params}`;
}
